<template>
    <th slot-scope="props"
        v-on="props.thEvents"
        v-bind="props.thAttrs"
    >
        <div class="row justify-content-center">
            <span class="VueTables__heading" :title="props.title">
                <vnodes :vnodes="props.heading"/>
            </span>
            <div class="sort">
                <vt-sort-control/>
            </div>
        </div>
    </th>
</template>
<style scoped>
.row{
    position: relative;
}
.row span{
    margin-right: 15px;
    margin-left: 5px;
}
.sort{
    position: absolute;
    right: 5px;
    top: 0;
    bottom: 0;
    margin: auto;
}
</style>
<script>
    import VtSortControl from "vue-tables-2/compiled/components/VtSortControl";
    export default {
        name: "VtTableHeading",
        components: {
            VtSortControl,
            vnodes: {
                functional: true,
                render: (h, ctx) => typeof ctx.props.vnodes === 'object' ? ctx.props.vnodes : [ctx.props.vnodes]
            }
        },
        props: ['props']
    }
</script>